function window_resized()
{
	var lst = jQuery(".aec-responsive");
	for(var i=0; i < lst.length; i++){
		var el = jQuery(lst[i]);
		var w = el.width();
		if (w <= 1170){
			el.addClass("size-md");
		} else {
			el.removeClass("size-md");
		}
		if (w <= 876){
			el.addClass("size-sm");
		} else {
			el.removeClass("size-sm");
		}
		if (w <= 583){
			el.addClass("size-xs");
		} else{
			el.removeClass("size-xs");
		}
	}
}

jQuery(window).resize(function (){
	window_resized();
})

jQuery(document).ready(function(){
	window_resized();
});

function processLinks()
{
	var cnt = jQuery(".aec-tiles-container .aec-tiles-container__inner").children().length;
	var total = jQuery(".aec-vendors-tiles").data("total");
	var tiles = jQuery(".aec-vendors-tiles").data("number-of-tiles");
	jQuery(".aec-vendors-tiles .counter-showing").html(cnt);
	jQuery(".aec-vendors-tiles .counter-total").html(total);
	if (cnt >= total){
		jQuery(".aec-show-all").addClass("disabled");
		jQuery(".aec-view-more").addClass("disabled");
	} else {
		jQuery(".aec-show-all").removeClass("disabled");
		jQuery(".aec-view-more").removeClass("disabled");
	}
	if (cnt <= tiles){
		jQuery(".aec-view-less").addClass("disabled");
	} else {
		jQuery(".aec-view-less").removeClass("disabled");
	}
	var state = getCurrentState();
	if (state.q != "" || state.category != 0 || state.country != 0 || state.region != 0 || jQuery(".aec-vendors-tiles").data("show-reset-link")) {
		jQuery(".aec-search-box").addClass("reset");
	} else {
		jQuery(".aec-search-box").removeClass("reset");
	}

}

function load(count, rebuild){
	if (window.AEC_Loading)
		return;
	window.AEC_Loading = true;

	console.log('>>>', rebuild);

	if (rebuild){
		if (jQuery('.aec-vendors-tiles__nav')) {
			jQuery(".aec-tiles-container").html("");
		} else {
			jQuery(".aec-tiles-container .aec-tiles-container__inner").html("");
		}

		jQuery(".aec-vendors-tiles").data("total", 0);
		processLinks();
		var start = 0;
	} else {
		var start = jQuery(".aec-tiles-container .aec-tiles-container__inner").children().length;
	}
	var url = jQuery(".aec-vendors-tiles").data("ajax-url") + "?action=aec_search&offset="+start+"&count="+count+"&q="+jQuery(".aec-vendors-tiles").data("search")+"&category="+jQuery(".aec-vendors-tiles").data("category")+"&industry="+jQuery(".aec-vendors-tiles").data("industry")+"&country="+jQuery(".aec-vendors-tiles").data("country")+"&region="+jQuery(".aec-vendors-tiles").data("region");
	jQuery(".aec-vendors-tiles").addClass("loading");
	jQuery.ajax({ "url" : url} ).done(function (a, b, c){
		if (b == "success"){
			if (jQuery('.aec-vendors-tiles__nav')) {
				jQuery(".aec-tiles-container").append(a)

				setTimeout(function () {
					jQuery(".aec-vendors-tiles__nav").stick_in_parent({
						"offset_top" : (parseInt(jQuery(".aec-vendors-tiles .top-controls").attr('data-offset-top')) + jQuery(".aec-vendors-tiles .top-controls").outerHeight())
					});
				}, 100);
			} else {
				jQuery(".aec-tiles-container .aec-tiles-container__inner").append(a)
			}

			if (jQuery('.aec-vendors-tiles__nav')) {
				var scrollTarget =  jQuery('.aec-vendors-tiles__nav');
			} else {
				if (jQuery(".aec-tiles-container .aec-tiles-container__inner").children().length >= start+1){
					var scrollTarget =  jQuery(".aec-tiles-container .aec-tiles-container__inner").children()[start];
				} else {
					var scrollTarget =  jQuery(".aec-tiles-container .aec-tiles-container__inner");
				}
			}



			jQuery(document.body).scrollTo(scrollTarget, 800, {
				offset : -1 * (window.aec_sticky_offset + jQuery(".aec-vendors-tiles .top-controls").outerHeight(false))
			});
			jQuery(".aec-vendor-tile").mouseenter(tileMouseEnter);
			jQuery(".aec-vendor-tile").mouseleave(tileMouseLeave);

			jQuery(".aec-vendors-tiles").data("total", c.getResponseHeader("X-Total-Results"));
			processLinks();
			if (jQuery(".aec-tiles-container .aec-tiles-container__inner").children().length == 0){
				jQuery(".aec-vendors-tiles").addClass("no-results");
			} else {
				jQuery(".aec-vendors-tiles").removeClass("no-results");
			}
			history.pushState(getCurrentState(), document.title);
	}
	}).always(function() {
		jQuery(".aec-vendors-tiles").removeClass("loading");
		window.AEC_Loading = false;
	});
}

function viewLess(cnt)
{
	if (window.AEC_Loading)
		return;
	window.AEC_Loading = true;
	var tiles = jQuery(".aec-vendors-tiles").data("number-of-tiles");
	var currentcnt = jQuery(".aec-tiles-container .aec-tiles-container__inner").children().length;
	if (currentcnt % tiles > 0)
		cnt = currentcnt % tiles
	if (currentcnt - cnt < cnt)
		cnt = currentcnt - cnt;

	var el = jQuery(".aec-tiles-container .aec-tiles-container__inner").children()[currentcnt-cnt-jQuery(".aec-vendors-tiles").data("number-of-tiles")];
	if (!el)
		el = jQuery(".aec-tiles-container .aec-tiles-container__inner");
	jQuery(document.body).scrollTo(el, 800, {
		offset : -1*(window.aec_sticky_offset+jQuery(".aec-vendors-tiles .top-controls").outerHeight(false)),
		onAfter : function (){
			jQuery('.aec-tiles-container .aec-tiles-container__inner > .aec-vendor-tile').slice(-1 * cnt).remove();
			processLinks();
			window.AEC_Loading = false;
		}
	});

}


function viewMore(tiles)
{
	load(tiles, false);
}

function getCurrentState()
{
	var state = {
		"offset"    : 0,
		"count"     : jQuery(".aec-tiles-container .aec-tiles-container__inner").children().length,
		"q"         : jQuery(".aec-vendors-tiles").data("search"),
		"category"  : jQuery(".aec-vendors-tiles").data("category"),
		"country"   : jQuery(".aec-vendors-tiles").data("country"),
		"region"    : jQuery(".aec-vendors-tiles").data("region")
	};
	return state;
}

var tile_hover_timeout = false;

function tileMouseEnter(e){
	if (tile_hover_timeout){
		clearTimeout(tile_hover_timeout);
	}
	tile_hover_timeout = setTimeout(function(){
		jQuery(e.currentTarget).find(".learn-more").css("display","inline-block");
		jQuery(e.currentTarget).find(".learn-more .bg").fadeTo("fast", 0.8, function (){
			jQuery(e.currentTarget).find(".learn-more .text").css("display", "block");
		});
	}, parseInt(jQuery(e.currentTarget).attr("data-fade-timeout")));
}

function tileMouseLeave(e){
	if (tile_hover_timeout){
		clearTimeout(tile_hover_timeout);
	}
	jQuery(e.currentTarget).find(".learn-more .text").css("display", "none");
	jQuery(e.currentTarget).find(".learn-more .bg").fadeTo("fast", 0, function (){
		jQuery(e.currentTarget).find(".learn-more").css("display","none");
	});
}

function initStickyOffset() {
	var stickyOffset = jQuery(".aec-vendors-tiles .top-controls").data("sticky-offset");
	var h = 0;
	if (Number.isInteger(stickyOffset)) {
		var h = stickyOffset;
	} else {
		jQuery(stickyOffset).each(function(idx, el){
			h += jQuery(el).outerHeight();
		});
	}

	if (h == 0 && jQuery('#masthead')) {
		h += jQuery('#masthead').outerHeight();
	}

	window.aec_sticky_offset = h;

	if (jQuery(".aec-vendors-tiles .top-controls").attr('data-offset-top') != h) {
		jQuery(".aec-vendors-tiles .top-controls").trigger("sticky_kit:detach");
	}
	jQuery(".aec-vendors-tiles .top-controls").attr('data-offset-top', h).stick_in_parent({
		"offset_top" : h
	});

	var h2 = (h + jQuery(".aec-vendors-tiles .top-controls").outerHeight());
	if (jQuery(".aec-vendors-tiles__nav").attr('data-offset-top') != h2) {
		jQuery(".aec-vendors-tiles__nav").trigger("sticky_kit:detach");
	}
	jQuery(".aec-vendors-tiles__nav").attr('data-offset-top', h).stick_in_parent({
		"offset_top" : h2
	});
}

// tiles page
jQuery(document).ready(function (){
	if (jQuery(".aec-vendors-tiles").length > 0){
		initStickyOffset();

		jQuery(window).resize(function() {
			initStickyOffset();
		});

		if (history.state == null){
			var url = location.href;
			url = url.replace(/aec-q=?([^&]+)?&?/g,'');
			url = url.replace(/aec-category=?[^&]?&?/g,'');
			url = url.replace(/\?$/g,'');
			history.replaceState(getCurrentState(), document.title, url);
		}
		window.addEventListener("popstate", function(e) {
			if (history.state){
				jQuery(".aec-vendors-tiles").data("search", history.state.q);
				jQuery("#aec-search").val(history.state.q)
				jQuery(".aec-vendors-tiles").data("category", history.state.category);
				jQuery("#aec-categories").val(history.state.category);
				jQuery("#aec-categories").trigger("chosen:updated");
				jQuery(".aec-vendors-tiles").data("country", history.state.country);
				jQuery("#aec-countries").val(history.state.country);
				jQuery("#aec-countries").trigger("chosen:updated");
				jQuery("#aec-regions").val(history.state.region);
				jQuery("#aec-regions").trigger("chosen:updated");
				load(history.state.count, true);
			}
		}, false)

		jQuery(".aec-vendors-tiles .aec-show-all").click(function (){
			if (jQuery(".aec-vendors-tiles .aec-show-all").hasClass("disabled"))
				return;
			load(999999, false);
		});

		jQuery(".aec-vendors-tiles .aec-view-less").click(function (){
			if (!jQuery(".aec-view-less").hasClass("disabled")){
				var tiles = jQuery(".aec-vendors-tiles").data("number-of-tiles");
				viewLess(tiles);
			}
		});
		jQuery(".aec-vendors-tiles .aec-view-more").click(function (){
			if (!jQuery(".aec-view-more").hasClass("disabled")){
				var tiles = jQuery(".aec-vendors-tiles").data("number-of-tiles");
				viewMore(tiles);
			}
		});
		jQuery(".aec-vendors-tiles #aec-search").keypress(function(e) {
			if(e.which == 13) {
				jQuery(document).trigger("aec.search", jQuery("#aec-search").val());
				jQuery(".aec-vendors-tiles").data("search", jQuery("#aec-search").val());
				var tiles = jQuery(".aec-vendors-tiles").data("number-of-tiles");
				load(tiles, true);
			}
		});

		jQuery(".aec-vendors-tiles #aec-categories").change(function (e){
			jQuery(".aec-vendors-tiles").data("category", jQuery("#aec-categories").val());
			var tiles = jQuery(".aec-vendors-tiles").data("number-of-tiles");
			load(tiles, true);
		});
		jQuery(".aec-vendors-tiles #aec-countries").change(function (e){
			jQuery(".aec-vendors-tiles").data("country", jQuery("#aec-countries").val());
			var tiles = jQuery(".aec-vendors-tiles").data("number-of-tiles");
			load(tiles, true);
		});
		jQuery(".aec-vendors-tiles #aec-regions").change(function (e){
			jQuery(".aec-vendors-tiles").data("region", jQuery("#aec-regions").val());
			var tiles = jQuery(".aec-vendors-tiles").data("number-of-tiles");
			load(tiles, true);
		});
		processLinks();

		jQuery(".aec-search-reset").click(function (){
			jQuery(".aec-vendors-tiles").data("search", ""),
			jQuery("#aec-search").val("")
			jQuery(".aec-vendors-tiles").data("category", 0)
			jQuery("#aec-categories").val(0);
			jQuery("#aec-categories").trigger("chosen:updated");
			jQuery(".aec-vendors-tiles").data("country", 0)
			jQuery("#aec-countries").val(0);
			jQuery("#aec-countries").trigger("chosen:updated");
			jQuery(".aec-vendors-tiles").data("region", 0)
			jQuery("#aec-regions").val(0);
			jQuery("#aec-regions").trigger("chosen:updated");
			jQuery(".aec-vendors-tiles").data("show-reset-link", "")
			var tiles = jQuery(".aec-vendors-tiles").data("number-of-tiles");
			load(tiles, true);
		});

		jQuery(".aec-vendor-tile").mouseenter(tileMouseEnter);
		jQuery(".aec-vendor-tile").mouseleave(tileMouseLeave);
	}
});

jQuery(document).ready(function (){
	if (jQuery(".aec-search-form").length > 0){
		var stickyOffset = jQuery(".aec-search-form").data("sticky-offset");
		var h = 0;
		if (Number.isInteger(stickyOffset))
			var h = stickyOffset;
		else{
			jQuery(stickyOffset).each(function(idx, el){
				h += jQuery(el).outerHeight();
			});
		}
		window.aec_sticky_offset = h;
	}
	jQuery(".aec-category-filter")
		.chosen({disable_search_threshold: 100, inherit_select_classes : true})
		.on("chosen:showing_dropdown keyup change", function (e, params){
			jQuery(".aec-search-form .aec-category-filter .chosen-drop li.active-result[data-option-array-index=0]").click(function (e){
				var url = "/search-products?aec-q=&aec-category="+jQuery(".aec-search-form .aec-category-filter").val();
				location.href = url;
			})
			jQuery(".aec-category-filter .chosen-drop li.active-result[data-option-array-index=0]").html("All");
		});
	jQuery(".aec-country-filter")
		.chosen({disable_search_threshold: 100, inherit_select_classes : true})
		.on("chosen:showing_dropdown chosen:updated", function (e, params){
			jQuery(".aec-country-filter .chosen-drop li.active-result[data-option-array-index=0]").html("All");
		});

	jQuery(".aec-search-box").click(function (e){
		if (e.target.tagName == "SPAN"){
			var ev = jQuery.Event("keypress");
			ev.which = 13;
			ev.keyCode = 13;
			jQuery(e.target).find("input[type=text]").trigger(ev);
		}
	});

	jQuery(".aec-search-form .aec-category-filter").change(function (e){
		var url = "/search-products?aec-q=&aec-category="+jQuery(".aec-search-form .aec-category-filter").val();
		location.href = url;
	});

	jQuery(".aec-search-form .aec-search-box input[type=text]").keypress(function(e) {
		if(e.which == 13) {
			jQuery(document).trigger("aec.search", jQuery(".aec-search-form .aec-search-box input[type=text]").val());
			var url = "/search-products?aec-q="+jQuery(".aec-search-form .aec-search-box input[type=text]").val()+"&aec-category="+jQuery(".aec-search-form .aec-category-filter").val();
			location.href = url;
		}
	})

})

window['AecVendorController'] = (function () {
	var vm = this;

	vm.init = function () {
		document.addEventListener('scroll', function (event) {
			var levels = jQuery('[data-level-code]');

			for (var i = 0; i < levels.length; i++) {
				// console.log(
				// 	levels[i].getAttribute('data-level-code'),
				// 	jQuery(levels[i]).offset().top,
				// 	window.scrollY
				// );

				var navRectHeight = document.querySelector('.aec-vendors-tiles__nav').offsetHeight
				var topControlsRectHeight = document.querySelector('.top-controls').offsetHeight

				// console.log(i, window.scrollY, jQuery(levels[i]).offset().top - navRectHeight - jQuery('header').height() - topControlsRectHeight);

				if (window.scrollY + 10 > jQuery(levels[i]).offset().top - navRectHeight - document.querySelector('header').offsetHeight - topControlsRectHeight && window['start_animate_anker'] !== true) {
					jQuery('.aec-vendors-tiles__nav-active').removeClass('aec-vendors-tiles__nav-active');
					jQuery('[data-level-code-nav="' + levels[i].getAttribute('data-level-code') +'"]').addClass('aec-vendors-tiles__nav-active');
				}
				// break;
			}


			// console.log('scrolling', levels);
		}, true /*Capture event*/);
	}

	vm.showLessOfGroup = function (refEl) {
		var levelWrapper = jQuery(refEl).parents('.aec-vendors-tiles__level').get(0);
		var allActiveTiles = jQuery(levelWrapper).find('.aec-vendor-tile').not(".aec-vendor-tile__hide");

		var dataNumberOfTiles = parseInt(levelWrapper.getAttribute('data-number-of-tiles'), 10);

		if (allActiveTiles.length <= dataNumberOfTiles) {
			return false;
		}

		var needHide = allActiveTiles.length % dataNumberOfTiles == 0 ? dataNumberOfTiles : allActiveTiles.length % dataNumberOfTiles;

		var i,x;
		for (i = allActiveTiles.length - 1, x = 1; i >= 0 && x <= needHide; i--, x++) {
			jQuery(allActiveTiles[i]).addClass('aec-vendor-tile__hide');
		}
		vm.updatePaginator(levelWrapper);
		jQuery(refEl).blur();
	}

	vm.showMoreOfGroup = function (refEl) {
		var levelWrapper = jQuery(refEl).parents('.aec-vendors-tiles__level').get(0);
		var allTiles = jQuery(levelWrapper).find('.aec-vendor-tile');
		var allActiveTiles = jQuery(levelWrapper).find('.aec-vendor-tile').not(".aec-vendor-tile__hide");
		var dataNumberOfTiles = parseInt(levelWrapper.getAttribute('data-number-of-tiles'), 10);

		// var needShow = allActiveTiles.length % dataNumberOfTiles == 0 ? dataNumberOfTiles : allActiveTiles.length % dataNumberOfTiles;
		var x = 0;
		for (var i = 0; i < allTiles.length; i++) {
			if (jQuery(allTiles[i]).hasClass('aec-vendor-tile__hide')) {
				jQuery(allTiles[i]).removeClass('aec-vendor-tile__hide')
				x++;
			}

			if (x >= dataNumberOfTiles) {
				break;
			}
		}

		vm.updatePaginator(levelWrapper);
		jQuery(refEl).blur();
	}

	vm.showAllOfGroup = function (refEl) {
		var levelWrapper = jQuery(refEl).parents('.aec-vendors-tiles__level').get(0);
		var allTiles = jQuery(levelWrapper).find('.aec-vendor-tile');
		allTiles.removeClass('aec-vendor-tile__hide');

		vm.updatePaginator(levelWrapper);
		jQuery(refEl).blur();
	}

	vm.updatePaginator = function (levelWrapper) {
		var counterShowingLevel = jQuery(levelWrapper).find('.counter-showing-level');
		var allActiveTiles = jQuery(levelWrapper).find('.aec-vendor-tile').not(".aec-vendor-tile__hide");
		var allTiles = jQuery(levelWrapper).find('.aec-vendor-tile');
		if (counterShowingLevel) {
			counterShowingLevel.text(allActiveTiles.size())
		}

		var dataNumberOfTiles = parseInt(levelWrapper.getAttribute('data-number-of-tiles'), 10);

		if (allActiveTiles.length > dataNumberOfTiles) {
			jQuery(levelWrapper).find('.aec-view-less-of-group').removeClass('disabled')
		} else {
			jQuery(levelWrapper).find('.aec-view-less-of-group').addClass('disabled')
		}

		if (allTiles.length == allActiveTiles.length) {
			jQuery(levelWrapper).find('.aec-view-more-of-group').addClass('disabled')
		} else {
			jQuery(levelWrapper).find('.aec-view-more-of-group').removeClass('disabled')
		}

		if (allTiles.length == allActiveTiles.length) {
			jQuery(levelWrapper).find('.aec-show-all-of-group').addClass('disabled')
		} else {
			jQuery(levelWrapper).find('.aec-show-all-of-group').removeClass('disabled')
		}
	}

	vm.goToLevelBlock = function (refEl, level) {
		var navWrapper = jQuery(refEl).parents('.aec-vendors-tiles__nav').get(0);

		jQuery(navWrapper).find('.aec-vendors-tiles__nav-active').removeClass('aec-vendors-tiles__nav-active');

		jQuery(refEl).parent().addClass('aec-vendors-tiles__nav-active');
		jQuery(refEl).blur();

		var refWrapper = document.querySelector('[data-level-code="' + level + '"]');

		var navRect = document.querySelector('.aec-vendors-tiles__nav').getBoundingClientRect()
		var topControlsRect = document.querySelector('.top-controls').getBoundingClientRect()
		var bodyRect = document.body.getBoundingClientRect();
		var refWrapperRect = refWrapper.getBoundingClientRect();

		// console.log(navRect.top + navRect.height, bodyRect.top, refWrapper.top);


		// var diff = refWrapper.top - (navRect.top + navRect.height);

		console.log({
			block: refWrapper,
			nav: navRect,
			body: bodyRect,
			offset: jQuery(refWrapper).offset(),
		});

		// jQuery([document.documentElement, document.body]).animate({
		// 	scrollTop: jQuery(refWrapper).offset().top - (90 + navHeight)
		// }, 500);

		window['start_animate_anker'] = true;
		jQuery([document.documentElement, document.body]).animate({
			scrollTop: jQuery(refWrapper).offset().top - navRect.height - jQuery('header').height() - topControlsRect.height
		}, 500, null, function () {
			setTimeout(function () {
				window['start_animate_anker'] = false;
			}, 100);
		});

		// jQuery([document.documentElement, document.body]).animate({scrollTop: 100});



		// refWrapper.scrollIntoView({
		// 	behavior: 'smooth'
		// });
	}

	vm.init();

	return this;
})();


//////////////////
// WEBPACK FOOTER
// ./assets/common.js
// module id = 2
// module chunks = 0